import { useEffect, useState } from "react";
import axios from "axios";
import { Quote, Star } from "lucide-react";

// Reseñas fijas. Las nuevas llegan del panel de Licencias → Reseñas.
export const REVIEWS = [
  {
    pharmacy: "Farmacia Gemma Baradad",
    city: "Rubí",
    rating: 5,
    text:
      "En Farmacia Baradad utilizamos FarmaClass, un programa muy útil, muy claro y fácil de usar, " +
      "que nos proporciona la información que necesitamos sobre nuestra gestión de ventas, nos muestra " +
      "cómo estamos trabajando cada miembro del equipo y ayuda a analizar las compras de los laboratorios " +
      "con los que trabajamos o queremos trabajar.",
  },
  {
    pharmacy: "Bernabé Morales · Grupo Calderón Salud",
    city: "Madrid y Castellón",
    rating: 5,
    text:
      "Desde el grupo Calderón Salud, confiamos en Pedro para la gestión de las dos oficinas de " +
      "farmacia que tenemos. Un crack, que se toma muy en serio su trabajo, cuida su programa como " +
      "a un hijo, y nos lleva el porcentaje de genéricos a la cima.",
  },
];

const Card = ({ r, featured = false }) => (
  <figure
    className={`${featured ? "w-full max-w-2xl" : "w-[320px] sm:w-[420px] shrink-0"} bg-white border border-slate-200 rounded-2xl p-6 sm:p-7 shadow-sm`}
    data-testid={`landing-review-${r.pharmacy.toLowerCase().replace(/\s+/g, "-")}`}
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-0.5" aria-label={`${r.rating} de 5`}>
        {Array.from({ length: r.rating }).map((_, i) => (
          <Star key={i} className="h-4 w-4 text-amber-500 fill-amber-500" />
        ))}
      </div>
      <Quote className="h-5 w-5 text-slate-300" />
    </div>
    <blockquote className="text-sm text-slate-700 leading-relaxed mt-4">“{r.text}”</blockquote>
    <figcaption className="mt-4 pt-4 border-t border-slate-100">
      <div className="text-sm font-bold text-slate-900">{r.pharmacy}</div>
      <div className="text-xs text-slate-500">{r.city}</div>
    </figcaption>
  </figure>
);

export const TestimonialsMarquee = () => {
  const [published, setPublished] = useState([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/reviews/published`)
      .then((r) => setPublished(r.data.reviews || []))
      .catch(() => {});
  }, []);
  const all = [...REVIEWS, ...published.map((r) => ({
    pharmacy: r.pharmacy_name, city: r.city, rating: r.rating, text: r.text,
  }))];
  return <Marquee reviews={all} />;
};

const Marquee = ({ reviews: REVIEWS }) => {
  // Con menos de 3 reseñas la cinta repetiría la misma tarjeta, así que la
  // destacamos estática. En cuanto haya 3 o más, arranca el movimiento solo.
  if (REVIEWS.length < 3) {
    const single = REVIEWS.length === 1;
    return (
      <div
        className={`max-w-6xl mx-auto px-4 sm:px-6 grid gap-5 ${single ? "max-w-3xl" : "md:grid-cols-2"}`}
        data-testid="landing-reviews-static"
      >
        {REVIEWS.map((r) => <Card key={r.pharmacy} r={r} featured />)}
      </div>
    );
  }
  const half = [...REVIEWS, ...REVIEWS];
  return (
    <div className="fc-marquee relative overflow-hidden" data-testid="landing-reviews-marquee">
      <div className="fc-marquee-track flex gap-5 w-max py-2">
        {[...half, ...half].map((r, i) => <Card key={`${r.pharmacy}-${i}`} r={r} />)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-slate-50 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-slate-50 to-transparent" />
    </div>
  );
};
